import { render, staticRenderFns } from "./borrow-management.vue?vue&type=template&id=3ae5ca3d&scoped=true"
import script from "./borrow-management.vue?vue&type=script&lang=js"
export * from "./borrow-management.vue?vue&type=script&lang=js"
import style0 from "./borrow-management.vue?vue&type=style&index=0&id=3ae5ca3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5ca3d",
  null
  
)

export default component.exports